import {
  AutocompleteInput,
  DateInput,
  FormGetter,
  FormInput,
  Grid,
} from '@kirz/mui-admin';
import { Typography } from '@mui/material';
import React from 'react';

import { ClientAutocompleteInput } from 'components/ClientAutocompleteInput';
import { EstateAutocompleteInput } from 'components/EstateAutocompleteInput';
import { DealContractForms } from 'constants/deal';
import { Obligations, PaymentForms } from 'constants/estate';
import { AmountInput } from 'shared/inputs';

export type DealStageDataVariant = 'booking' | 'deal';

/**
 * Form shown in the deal stage-change modal when a deal moves to
 * "Бронирование" (booking) or "Успех" (deal). Lets the user fill in the deal
 * data required by these stages right from the prompt.
 *
 * Rendered inside a `showPrompt` Form, so it relies on the surrounding
 * react-hook-form context. The "Клиент или покупатель" rule (at least one of
 * sellerId / clientId) is validated by the caller after submit.
 */
export function DealStageDataForm({
  variant,
}: {
  variant: DealStageDataVariant;
}) {
  const isDeal = variant === 'deal';

  return (
    <>
      <Grid xs={12}>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          Информация
        </Typography>
      </Grid>
      {isDeal && (
        <DateInput name="dealDate" label="Дата сделки" required md={6} />
      )}
      <ClientAutocompleteInput name="sellerId" label="Клиент" md={6} />
      <ClientAutocompleteInput name="clientId" label="Покупатель" md={6} />
      <FormGetter
        names={['sellerId']}
        render={({ sellerId }) => (
          <EstateAutocompleteInput
            {...({ name: 'estateId', sellerId, required: true, md: 6 } as any)}
          />
        )}
      />
      <AutocompleteInput
        name="userId"
        mode="hasura"
        source="user"
        label="Эксперт"
        selection="id fullName"
        itemText="fullName"
        required
        md={6}
      />
      <AutocompleteInput
        name="obligations"
        label="Обременения"
        options={Obligations}
        required
        md={6}
      />

      <Grid xs={12}>
        <Typography variant="subtitle1" sx={{ mb: 1, mt: 1 }}>
          Стоимость
        </Typography>
      </Grid>
      {isDeal && (
        <FormInput
          name="contractNumber"
          label="Номер договора"
          required
          md={6}
        />
      )}
      <AutocompleteInput
        name="paymentForm"
        label="Форма оплаты"
        options={PaymentForms}
        required
        md={6}
      />
      <FormInput
        name="dealPrice"
        label="Сумма сделки"
        type="number"
        {...AmountInput}
        required
        md={6}
      />
      <FormInput
        name="dealContractPrice"
        label="Сумма сделки по договору"
        type="number"
        {...AmountInput}
        required
        md={6}
      />
      <AutocompleteInput
        name="contractForm"
        label="Форма договора"
        options={DealContractForms}
        required
        md={6}
      />
    </>
  );
}
